<template>
  <Modal v-model="logoConfigModal" :title="$t('key1001827')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="logoConfigChange">
    <Form :label-width="100" @submit.native.prevent>
      <Row>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem label="LOGO：" class="required_style_label">
            <Upload
              class="upload_styles"
              ref="upload"
              type="drag"
              name="files"
              :headers="headObj"
              :action="fileApi"
              :data="uploadData"
              :show-upload-list="false"
              :before-upload="file => beforeUpload(file, 'logo')"
              :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'logo')"
              :format="['jpg', 'jpeg', 'png']"
              :max-size="20480"
              :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'logo')"
              :on-exceeded-size="handleMaxSize">
              <div class="preview_box" v-if="logoImg">
                <img :src="logoImg"/>
                <div class="preview_mask">{{ $t('key1002385') }}</div>
              </div>
              <div class="upload_icon_box" v-else>
                <Icon type="md-add" size="22" color="#3399ff" class="position-relative" style="top: 4px;"/>
                <span class="font-size-12">{{ $t('key1002386') }}</span>
              </div>
            </Upload>
            <p class="font-size-12 color-666">{{ $t('key1002568') }}</p>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002557')" class="required_style_label">
            <Upload
              class="upload_styles"
              ref="upload"
              type="drag"
              name="files"
              :headers="headObj"
              :action="fileApi"
              :data="uploadData"
              :show-upload-list="false"
              :before-upload="file => beforeUpload(file, 'ico')"
              :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'ico')"
              :format="['ico']"
              :max-size="20480"
              :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'ico')"
              :on-exceeded-size="handleMaxSize">
              <div class="preview_box ico" v-if="icoImg">
                <img :src="icoImg"/>
                <div class="preview_mask">{{ $t('key1002385') }}</div>
              </div>
              <div class="upload_icon_box" v-else>
                <Icon type="md-add" size="22" color="#3399ff" class="position-relative" style="top: 4px;"/>
                <span class="font-size-12">{{ $t('key1002386') }}</span>
              </div>
            </Upload>
            <p class="font-size-12 color-666">{{ $t('key1002569') }}</p>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="logoConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="logoConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonSessionStorage, handleUploadImageAddress, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'logoConfigModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"&isOriginalName=true&isTemp=N',
      uploadData: {},
      logoConfigModal: false,
      logoImg: null,
      icoImg: null,
      configParamKey: null,
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化数据
    initLogoConfigData(paramKey, obj) {
      if (obj) {
        this.logoImg = obj.logoImg;
        this.icoImg = obj.icoImg;
      }
      this.configParamKey = paramKey;
      this.logoConfigModal = true;
    },
    // 确定按钮
    logoConfigBtn() {
      if (this.logoImg && this.icoImg) {
        let obj = {
          logoImg: this.logoImg,
          icoImg: this.icoImg,
        };
        let queryList = [
          {
            businessId: this.userInfo.merchantId,
            paramKey: this.configParamKey,
            paramValue: JSON.stringify(obj),
          }
        ];
        saveErpCommonSettingParam(queryList).then(() => {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
          this.logoConfigModal = false;
          this.$emit('updateConfigData', true);
        });
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002603'));
        return false;
      }
    },
    // 上传前校验
    beforeUpload(file, type) {
      const isLogo = type === 'logo';
      const allowTypes = isLogo ? ['image/png', 'image/jpeg'] : ['image/x-icon'];
      const sizeRule = isLogo ? {width: 210, height: 22} : {width: 16, height: 16};
      // 格式校验
      if (!allowTypes.includes(file.type)) {
        this.$Message.error(isLogo ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002604') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002605'));
        return false;
      }
      // 尺寸校验（异步）
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const {width, height} = img;
          URL.revokeObjectURL(img.src);
          if (width !== sizeRule.width || height !== sizeRule.height) {
            this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002602')} ${sizeRule.width} × ${sizeRule.height}px`);
            reject(false);
          } else {
            resolve(true);
          }
        };
        img.onerror = () => {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002376'));
          reject(false);
        };
      });
    },
    // 上传成功
    uploadSuccess(response, file, fileList, type) {
      if (response.code !== 0) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457'));
        return;
      }
      if (type === 'logo') {
        this.logoImg = handleUploadImageAddress(response.datas[0]);
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002606'));
      } else {
        this.icoImg = handleUploadImageAddress(response.datas[0]);
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002607'));
      }
    },
    // 校验文件格式
    handleFormatError(file, fileList, type) {
      let v = this;
      let text = type === 'logo' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002545') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002546');
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002532')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002533')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101')}${text}`,
        duration: 5
      });
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 监听弹窗
    logoConfigChange(value) {
      if (!value) {
        this.logoImg = null;
        this.icoImg = null;
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.upload_styles {
  width: 212px;
}

.preview_box {
  position: relative;
  width: 210px;
  height: 60px;
  border-radius: 4px;
  /*overflow: hidden;*/
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dcdfe6;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .preview_mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    cursor: pointer;
    transition: all 0.3s;
  }

  &:hover .preview_mask {
    opacity: 1;
  }
}

.preview_box.ico {
  width: 40px;
  height: 40px;

  .preview_mask {
    width: 210px;
  }
}


.upload_icon_box {
  width: 210px;
  height: 60px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

</style>
